/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Warehouse_Sales_Low_Stock_TitleInputs */

const vi_warehouse_sales_low_stock_title = /** @type {(inputs: Warehouse_Sales_Low_Stock_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sản phẩm sắp hết hàng`)
};

/**

* @param {Warehouse_Sales_Low_Stock_TitleInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const warehouse_sales_low_stock_title = /** @type {((inputs?: Warehouse_Sales_Low_Stock_TitleInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Warehouse_Sales_Low_Stock_TitleInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_warehouse_sales_low_stock_title(inputs)
});